// extracted by mini-css-extract-plugin
export default {"button":"BasicButton_button__3Bijy","buttonText":"BasicButton_buttonText__-UbuM","buttonIcon":"BasicButton_buttonIcon__oAgFJ"};